<template lang="pug">
	.radio-wrap-v2(:class="customClass")
		.radio-border(:class="[{'checked': value == radioValue, 'white-label-input': isWhiteLabel}, fontSize]" @click="emitClick($event); emitChange($event)")
			.radio-mark
			input(:id="id" type="radio" :name="name" @change="emitChange($event)" :checked="value == radioValue" @click="emitClick($event)" :aria-labelledby="labelledBy" @focus="onFocus($event)" @blur="onBlur($event)")
		.radio-text(:class="fontSize")
			span(v-html="label" @click="emitClick($event); emitChange($event)" :id="labelledBy")

</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
.radio-wrap-v2
	display: flex
	.radio-border
		flex-grow: 0
		position: relative
		background-color: #fff
		display: inline-block
		cursor: pointer
		margin-top: 3px
		min-width: 20px
		width: 20px
		max-width: 20px
		height: 20px
		border-radius(50%)
		border: 1px solid sfc-pale-gray
		margin-right: 8px
		vertical-align: middle

		&.white-label-input
			&.radio-focus
				prudential-box-shadow()

		&.xxs
			margin-top: 3px
		&.xs
			margin-top: 3px
		&.sm
			margin-top: 3px
		&.normal
			margin-top: 3px
		&.md
			margin-top: 5px
		&.lg
			margin-top: 8px
		&.lg-plus
			margin-top: 11px
		&.xl
			margin-top: 17px

		@media (max-width: 757px)
			margin-top: 0
			&.xxs
				margin-top: 2px
			&.xs
				margin-top: 2px
			&.sm
				margin-top: 2px
			&.normal
				margin-top: 2px
			&.md
				margin-top: 1px
			&.lg
				margin-top: 3px
			&.lg-plus
				margin-top: 6px
			&.xl
				margin-top: 12px

		input[type="radio"]
			border: 0
			height: 1px
			width: 1px
			margin: -1px
			clip: rect(0 0 0 0)
			overflow: hidden
			padding: 0
			position: absolute

		.radio-mark
			display:none

		&.checked
			border: 1px solid sfc-blue-border
			.radio-mark
				display: block
				background: #2f80ce
				width: 10px
				height: 10px
				border-radius(50%)
				border: 1px solid sfc-blue-border
				position: absolute
				top: 4px
				left: 4px

		@media (max-width: 757px)
			min-width: 30px
			width: 30px
			max-width: 30px
			height: 30px
			&.checked
				border: 1px solid sfc-blue-border
				.radio-mark
					display: block
					background: #2f80ce
					width: 16px
					height: 16px
					border-radius(50%)
					border: 1px solid sfc-blue-border
					position: absolute
					top: 6px
					left: 6px


	.radio-text
		flex-grow: 1
		font-size: body-font-size
		span
			position: relative
			margin: 0
			padding: 0
			display: inline-block
			clear: none
			cursor: pointer
			white-space: normal

		@media(max-width: 575px)
			font-size: body-font-size-md
		@media(max-width: 757px)
			margin-bottom: 10px

		&.xxs
			font-size: body-font-size-xxs
		&.xs
			font-size: body-font-size-xs
		&.sm
			font-size: body-font-size-sm
		&.normal
			font-size: body-font-size
		&.md
			font-size: body-font-size-md
		&.lg
			font-size: body-font-size-lg
		&.lg-plus
			font-size: body-font-size-lg-plus
		&.xl
			font-size: body-font-size-xl


</style>

<script>
export default {
	props: {
		fontSize: {
			default: ""
		},
		label:{
			required: true,
			default: ""
		},
		value:{
			required: true,
			default: undefined
		},
		radioValue:{
			required: true,
			default: undefined
		},
		name: {
			required: true
		},
		labelledBy: {
			default: undefined
		},
		isWhiteLabel: {
			default: false
		},
		customClass: {
			default: undefined
		}
	},
	data() {
		let randomNumber = Math.ceil(Math.random()*1000000)
		let id = `sfc-radio-${randomNumber}`
		return {
			id,
			previousValue: undefined
		}
	},
	methods: {
		emitChange(event) {
			this.$emit('input', this.radioValue)
			this.$emit('change', event)
			this.previousValue = this.value
		},
		emitClick(event) {
			this.$emit('click', event)
		},
		onFocus(event){
			this.$emit('focus')
			if(this.$props.isWhiteLabel){
				document.getElementById(event.target.id).parentElement.classList.add('radio-focus')
			}
		},
		onBlur(event){
			this.$emit('blur')
			if(this.$props.isWhiteLabel){
				document.getElementById(event.target.id).parentElement.classList.remove('radio-focus')
			}
		}
	}
}
</script>
